module.exports = __webpack_public_path__ + "static/img/k16_16.9598855.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/k16_16.png
// module id = 3S7A
// module chunks = 0